export default __webpack_public_path__ + "static/media/HAAPA Final Logo_White-01.b98ef5e8.png";